import classnames from 'classnames/bind';
import styles from './frame.module.scss';

const classNameBuilder = classnames.bind(styles);

export const Frame = ({ children, isStyleFrame }) => (
    <div
        className={classNameBuilder({ 'floating-frame': isStyleFrame, 'frame-codeless': !isStyleFrame })}
        id="codeless-frame"
    >
        {children}
    </div>
);
